import { render, staticRenderFns } from "./Addresses.vue?vue&type=template&id=b2e59b10&scoped=true"
import script from "./Addresses.vue?vue&type=script&lang=js"
export * from "./Addresses.vue?vue&type=script&lang=js"
import style0 from "./Addresses.vue?vue&type=style&index=0&id=b2e59b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e59b10",
  null
  
)

export default component.exports